import {
  styled as muiStyled,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Stack,
  Typography,
  Divider,
  TextField,
} from '@mui/material';

import { COLORS } from '../../../../themes/colors';
import styled from 'styled-components';

export const Wrapper = muiStyled(Stack)(() => ({
  padding: 0,
}));

export const Content = styled.div`
  display: flex;
  flex-direction: row;

  & .MuiOutlinedInput-notchedOutline  {
    border-radius: 0;
  }

  & .MuiOutlinedInput-notchedOutline {
    :first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  
  & .MuiOutlinedInput-notchedOutline {
    :last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Overlay = muiStyled(Stack)(() => ({
  display: 'block',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2,
  width: '100%',
  height: '100%',
  background: 'transparent',
}));

export const Container = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  marginTop: '4px',
  marginBottom: '8px',
}));

export const DateContainer = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  width: '100%',
  padding: '14px',
  gap: '8px'
}));

export const PeriodTitle = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 600,
  fontSize: '14px',
  color: `${COLORS.DARK['+3']}`,
}));

export const DividerStyled = muiStyled(Divider)(() => ({
  marginTop: '8px',
}));

export const DateContent = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'center',
  gap: '10px',
  width: '100%',
  maxWidth: '206px',
  margin: '0 auto',
}));

export const TextFieldStyled = muiStyled(TextField)(() => ({
  color: `${COLORS.DARK['+5']}`,
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',

  '& .MuiInput-underline:before': {
    borderBottom: `1px solid ${COLORS.DARK['+1']}`,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));

export const ToStyled = muiStyled(Typography)(() => ({
  color: `${COLORS.GRAY.MAIN}`,
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
}));

// When have radio
export const FormControlStyled = muiStyled(FormControl)(() => ({}));

export const RadioGroupStyled = muiStyled(RadioGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'flex-start',
  marginLeft: '24.5px',
}));

export const RadioGroupSelect = muiStyled(RadioGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'flex-start',
  marginLeft: '8.5px',
}));

export const FormLabelStyled = muiStyled(FormControlLabel)(() => ({
  color: `${COLORS.DARK['+5']}`,
}));

export const LabelStyled = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
}));

export const RadioStyled = muiStyled(Radio)(() => ({
  color: `${COLORS.PRIMARY.BLUE['-4']}`,
  '&.Mui-checked': {
    color: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));
